import steps from "./stepsMap";
import ReactGA from 'react-ga';

const sendAnalytics = (currentProps, prevProps, key) => {
      if(currentProps.setVerified && currentProps.setVerified !== prevProps.setVerified){
        execute('LandingPage', key)
      }
      else if(currentProps.getStarted !== prevProps.getStarted || prevProps.activeStepIndex !== currentProps.activeStepIndex){
        let activeStep = steps.find(step => step.stepIndex === currentProps.activeStepIndex);
        if(activeStep.stepName){
            execute(activeStep.stepName, key) 
        }
      }
      else if(currentProps.formSubmitted && prevProps.formSubmitted !== currentProps.formSubmitted){
        execute('AcknowledgementPage', key) 
      }
}

export const execute = (content, key) => {
  if(window.location.host.includes("connect.copart")){
    ReactGA.initialize(key);
    ReactGA.pageview(content);
  }
}

export default sendAnalytics;



// WEBPACK FOOTER //
// ./src/containers/PickupForm/sendAnalytics.js